import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Color } from "../../theme/Color";
import Logo from "../Logo";
import HamburgerIcon from "../Menus/HamburgerIcon";
import Spacer from "../Spacer";

interface Props {
  showMenu: boolean;
  setShowMenu: (boolean) => any;
}

const StyledHeader = styled(Row)`
  position: absolute;
  width: 100%;
  top: 0;
  padding: 1rem;
  margin: 0;
  background: ${Color.Orange5};
  z-index: 99999;
  color: ${Color.White};
  & a {
  }
`;

const PublicMobileHeader = ({ showMenu, setShowMenu }: Props) => {
  return (
    <StyledHeader middle="xs">
      <Col xs={9} sm={6}>
        <Row middle="xs">
          <Logo />
        </Row>
      </Col>
      <Col xs={3} sm={6}>
        <Row end="xs" middle="xs">
          <Spacer right={2}>
            <HamburgerIcon
              showCloseIcon={showMenu}
              onClick={() => {
                showMenu ? setShowMenu(false) : setShowMenu(true);
              }}
            />
          </Spacer>
        </Row>
      </Col>
    </StyledHeader>
  );
};

export default PublicMobileHeader;
